/**
 * Component to render icons from the Material Icons repository
 * https://material.io/resources/icons/
 * @param fill 'outlined' for Oulined icons or '' filled icons
 * @author elkin.contreras@zabud.com.co
 */

import React from 'react'

const MaterialIcon = ({ fill, name, size, extraClass }) => {
   const fillClass = fill ? `material-icons-${fill}` : 'material-icons'

   return (
      <span
         className={`${fillClass} ${extraClass ?? ''}`}
         style={size && { fontSize: `${size}px` }}
      >
         {name}
      </span>
   )
}

export default MaterialIcon
